import { render, staticRenderFns } from "./my-transfer.vue?vue&type=template&id=6426fd3a&scoped=true"
import script from "./my-transfer.vue?vue&type=script&lang=js"
export * from "./my-transfer.vue?vue&type=script&lang=js"
import style0 from "./my-transfer.vue?vue&type=style&index=0&id=6426fd3a&prod&lang=scss&scoped=true"
import style1 from "./my-transfer.vue?vue&type=style&index=1&id=6426fd3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6426fd3a",
  null
  
)

export default component.exports